export default __webpack_public_path__ + "static/media/Incidents-Main.a637ee78.png";